import { Text } from '@factorialco/deprecated-design-system'

export const Label = ({ label }: { label?: string | null }) => {
  return <Text.Normal size="200">{label}</Text.Normal>
}
